import { useApiMutation } from '@/hooks/useApiMutation';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';

interface AuthUrlResponse {
  url: string;
}

/**
 * Returns the QuickBooks OAuth authorization URL, then redirects.
 * Call mutate() and in onSuccess open response.url in a new tab / same window.
 */
export function useConnectQuickBooks() {
  return useApiMutation<AuthUrlResponse, void>({
    mutationFn: () => apiGet<AuthUrlResponse>(operationsClient, settingsEndpoints.qbAuthUrl()),
  });
}
